import React, {} from 'react';

import BaseElement from './base';
import Paragraph from './paragraph';
import Header from './header';
import SpinnerElement from './spinner';
import BulletedList from './bulleted-list';
import NumberedList from './numbered-list';
import ListItem from './list-item';
import CheckListItem from './check-list-item';
import BlockQuote from './block-quote';
import Link from './link';
import Image from './image';
import Button from './button';
import AuthenticatorButton from './authenticator-button';
import URLEmbed from './url-embed';
import Divider from './divider';
import Mention from './mention';
import SingleProducerMeeting from './single-producer-meeting';
import HTFile from './ht-file';
import EventTemplateEditor from './event/editor/template';
import EventEditor from './event/editor';
import Columns, { Column } from './columns';
import Layout from './layout';
import Icon from './icon';
import SiteNav, { Region, Item } from './site-nav';
import HTForm from './ht-form/main/react';
import HTMLImporter from './html-importer';
import SourceCodeRegion from './source-code-region';
import Table, { TableBody, TableRow, TableCell } from './table';
import Product from './product/react';
import SynchronizedPageRegion from './synchronized-page-region';
import EmailQuote from './email-quote';
import MemberCalendar from './member-calendar/react';
import DataCollection, { DataCollectionRow } from './data-collection';
import DataCollectionRowPage from './data-collection-row-page';
import ToggleListItem, { ToggleListHead, ToggleListBody } from './toggle-list-item';
import Indentation from './indentation';
import TemplateCloner from './template-cloner';
import FavouritePageNodeCloner from './favourite-page-node-cloner';
import Canvas from './canvas';
import VideoCanvas from './video-canvas';
import SignaturePanel from './signature-panel';
import LastUpdated from './last-updated';
import PageAuthor from './page-author';
import AIAssistant from './ai-assistant';
import YouTubeVideo from './youtube';
import Directory from './directory';
import Gallery from './gallery';
import GalleryItem from './gallery/gallery-item';
import Carousel from './carousel';
import CarouselItem from './carousel/carousel-item';

import types from './types';

function Element(props) {

  function renderMain() {

    const { children, element } = props;

    const elementType = element.type;

    if (elementType === 'site-nav') {
      return <SiteNav {...props} />;
    } else if (elementType === 'site-nav-region') {
      return <Region {...props} />;
    } else if (elementType === 'site-nav-item') {
      return <Item {...props} />;
    } else if (elementType === types.BLOCK_QUOTE) {
      return <BlockQuote {...props}>{children}</BlockQuote>;
    } else if (elementType === types.BULLETED_LIST) {
      return <BulletedList {...props}>{children}</BulletedList>;
    } else if (elementType === types.HEADING_ONE) {
      return <Header type="heading-one" {...props}>{children}</Header>;
    } else if (elementType === types.HEADING_TWO) {
      return <Header type="heading-two" {...props}>{children}</Header>;
    } else if (elementType === types.HEADING_THREE) {
      return <Header type="heading-three" {...props}>{children}</Header>;
    } else if (elementType === types.HEADING_FOUR) {
      return <Header type="heading-four" {...props}>{children}</Header>;
    } else if (elementType === types.HEADING_FIVE) {
      return <Header type="heading-five" {...props}>{children}</Header>;
    } else if (elementType === types.HEADING_SIX) {
      return <Header type="heading-six" {...props}>{children}</Header>;
    } else if (elementType === types.LINK) {
      return <Link {...props} />;
    } else if (elementType === types.LIST_ITEM || elementType === types.BULLETED_LIST_ITEM || elementType === types.NUMBERED_LIST_ITEM) {
      return <ListItem {...props}>{children}</ListItem>;
    } else if (elementType === types.NUMBERED_LIST) {
      return <NumberedList {...props}>{children}</NumberedList>;
    } else if (elementType === types.CHECK_LIST_ITEM) {
      return <CheckListItem {...props} />;
    } else if (elementType === types.IMAGE) {
      return <Image {...props} />;
    } else if (elementType === types.SPINNER) {
      return <SpinnerElement {...props} />;
    } else if (elementType === types.COLUMNS) {
      return <Columns {...props}>{children}</Columns>;
    } else if (elementType === types.COLUMN) {
      return <Column {...props}>{children}</Column>;
    } else if (elementType === types.LAYOUT) {
      return <Layout {...props}>{children}</Layout>;
    } else if (elementType === types.ICON) {
      return <Icon {...props}>{children}</Icon>;
    } else if (elementType === types.BUTTON) {
      return <Button {...props}>{children}</Button>;
    } else if (elementType === types.AUTHENTICATOR_BUTTON) {
      return <AuthenticatorButton {...props}>{children}</AuthenticatorButton>;
    } else if (elementType === types.URL_EMBED) {
      return <URLEmbed {...props}>{children}</URLEmbed>;
    } else if (elementType === types.DIVIDER) {
      return <Divider {...props}>{children}</Divider>;
    } else if (elementType === types.MENTION) {
      return <Mention {...props}>{children}</Mention>;
    } else if (elementType === types.SINGLE_PRODUCER_MEETING) {
      return <SingleProducerMeeting {...props}>{children}</SingleProducerMeeting>;
    } else if (elementType === types.HT_FILE) {
      return <HTFile {...props}>{children}</HTFile>;
    } else if (elementType === types.HT_STARTUP_EVENT_TEMPLATE) {
      return <EventTemplateEditor {...props}>{children}</EventTemplateEditor>;
    } else if (elementType === types.HT_STARTUP_EVENT) {
      return <EventEditor {...props}>{children}</EventEditor>;
    } else if (elementType === types.BASE) {
      return <BaseElement {...props}>{children}</BaseElement>;
    } else if (elementType === types.FORM) {
      return <HTForm {...props}>{children}</HTForm>;
    } else if (elementType === types.SIGNUP_FORM) {
      return <HTForm {...props}>{children}</HTForm>;
    } else if (elementType === types.HTML_IMPORTER) {
      return <HTMLImporter {...props}>{children}</HTMLImporter>;
    } else if (elementType === types.SOURCE_CODE_REGION) {
      return <SourceCodeRegion {...props}>{children}</SourceCodeRegion>;
    } else if (elementType === types.TABLE) {
      return <Table {...props}>{children}</Table>;
    } else if (elementType === types.TABLE_BODY) {
      return <TableBody {...props}>{children}</TableBody>;
    } else if (elementType === types.TABLE_ROW) {
      return <TableRow {...props}>{children}</TableRow>;
    } else if (elementType === types.TABLE_CELL) {
      return <TableCell {...props}>{children}</TableCell>;
    } else if (elementType === types.PRODUCT) {
      return <Product {...props} />;
    } else if (elementType === types.SYNCHRONIZED_PAGE_REGION) {
      return <SynchronizedPageRegion {...props} />;
    } else if (elementType === types.EMAIL_QUOTE) {
      return <EmailQuote {...props} />;
    } else if (elementType === types.MEMBER_CALENDAR) {
      return <MemberCalendar {...props} />;
    } else if (elementType === types.DATA_COLLECTION) {
      return <DataCollection {...props} />;
    } else if (elementType === types.DATA_COLLECTION_ROW) {
      return <DataCollectionRow {...props} />;
    } else if (elementType === types.DATA_COLLECTION_ROW_PAGE) {
      return <DataCollectionRowPage {...props} />;
    } else if (elementType === types.TOGGLE_LIST_ITEM) {
      return <ToggleListItem {...props} />;
    } else if (elementType === types.TOGGLE_LIST_HEAD) {
      return <ToggleListHead {...props} />;
    } else if (elementType === types.TOGGLE_LIST_BODY) {
      return <ToggleListBody {...props} />;
    } else if (elementType === types.INDENTATION) {
      return <Indentation {...props} />;
    } else if (elementType === types.TEMPLATE_CLONER) {
      return <TemplateCloner {...props} />;
    } else if (elementType === types.FAVOURITE_PAGE_NODE_CLONER) {
      return <FavouritePageNodeCloner {...props} />;
    } else if (elementType === types.CANVAS) {
      return <Canvas {...props} />;
    } else if (elementType === types.VIDEO_CANVAS) {
      return <VideoCanvas {...props} />;
    } else if (elementType === types.SIGNATURE_PANEL) {
      return <SignaturePanel {...props} />;
    } else if (elementType === types.LAST_UPDATED) {
      return <LastUpdated {...props} />;
    } else if (elementType === types.PAGE_AUTHOR) {
      return <PageAuthor {...props} />;
    } else if (elementType === types.AI_ASSISTANT) {
      return <AIAssistant {...props} />;
    } else if (elementType === types.YOUTUBE) {
      return <YouTubeVideo {...props} />;
    } else if (elementType === types.DIRECTORY) {
      return <Directory {...props} />;
    } else if (elementType === types.GALLERY) {
      return <Gallery {...props}>{children}</Gallery>;
    } else if (elementType === types.GALLERY_ITEM) {
      return <GalleryItem {...props}>{children}</GalleryItem>;
    } else if (elementType === types.CAROUSEL) {
      return <Carousel {...props}>{children}</Carousel>;
    } else if (elementType === types.CAROUSEL_ITEM) {
      return <CarouselItem {...props}>{children}</CarouselItem>;
    } else {
      return <Paragraph {...props}>{children}</Paragraph>;
    }

  }

  return renderMain();

}

export default Element;
export { default as Leaf } from './leaf';